import {createAxiosInstance} from './base.api'

const taskApi = 'tasks'

export const getTask = (id, errorMethod) => createAxiosInstance(taskApi).get(`/${id}`)
.catch(error => errorMethod(error))

export const updateTask = (id, task, successMethod, errorMethod) => createAxiosInstance(taskApi).put(`/${id}`, task)
.then(response => successMethod(response))
.catch(error => errorMethod(error))

export const taskOrderUp = (id, errorMethod) => createAxiosInstance(taskApi).put(`/${id}/order-up`, {})
.catch(error => errorMethod(error))

export const taskOrderDown = (id, errorMethod) => createAxiosInstance(taskApi).put(`/${id}/order-down`, {})
.catch(error => errorMethod(error))

export const taskStart = (id, errorMethod) => createAxiosInstance(taskApi).put(`/${id}/start`, {})
.catch(error => errorMethod(error))

export const taskFinish = (id, errorMethod) => createAxiosInstance(taskApi).put(`/${id}/finish`, {})
.catch(error => errorMethod(error))

export const taskCancel = (id, errorMethod) => createAxiosInstance(taskApi).put(`/${id}/cancel`, {})
.catch(error => errorMethod(error))


export const createSubtask = (taskid, subtask, successMethod, errorMethod) => createAxiosInstance(taskApi).post(`/${taskid}/subtasks`, subtask)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))

export const bulkCreateSubtask = (taskid, subtasks, successMethod, errorMethod) => createAxiosInstance(taskApi).post(`/${taskid}/bulk-subtasks`, subtasks)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))

export const createWorklog = (taskid, worklog, successMethod, errorMethod) => createAxiosInstance(taskApi).post(`/${taskid}/worklogs`, worklog)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))

export const createTaskResource = (taskid, taskResource, successMethod, errorMethod) => createAxiosInstance(taskApi).post(`/${taskid}/taskResources`, taskResource)
.then((res) => successMethod(res))
.catch((error) => errorMethod(error))

